import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { ProtectedRoute, Auth } from '../Auth'
import ScrollToTop from './ScrollToTop';
import Landing from '../Landing/Landing'
import ChatApp from '../ChatApp/ChatApp'
import Organization from '../Organization/Organization'
import GoogleOAuthCallback from '../Organization/GoogleOAuthCallback'
import MCPOAuthCallback from '../Organization/MCPOAuthCallback'
import LegalTerms from '../Landing/Legal/LegalTerms'
import SimpleDisclosure from '../Landing/Legal/SimpleDisclosure'
import Policy from '../Landing/Legal/Policy'
import AboutUs from '../Landing/AboutUs'

const AppRouter = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public routes */}
        <Route path="/home" element={<Landing />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/legalTerms" element={<LegalTerms />} /> 
        <Route path="/simpleDisclosure" element={<SimpleDisclosure />} /> 
        <Route path="/policy" element={<Policy />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        
        {/* Authentication route */}
        <Route path="/auth" element={<Auth />} />
        
        {/* Protected routes - require authentication */}
        <Route 
          path="/app" 
          element={
            <ProtectedRoute>
              <ChatApp />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/app/organization" 
          element={
            <ProtectedRoute>
              <Organization />
            </ProtectedRoute>
          } 
        />

        <Route
          path="/oauth/google/callback"
          element={
            <ProtectedRoute>
              <GoogleOAuthCallback />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/oauth/mcp/callback"
          element={
            <ProtectedRoute>
              <MCPOAuthCallback />
            </ProtectedRoute>
          }
        />

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </Router>
  )
}

export default AppRouter
